import * as React from 'react';

function SvgOrbit(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={28}
      height={28}
      overflow="visible"
      {...props}
    >
      <g transform="rotate(-32 12 12)">
        <ellipse
          cx="12"
          cy="12"
          rx="10"
          ry="3.5"
          fill="none"
          stroke="#FFF"
          strokeWidth="1.7"
          opacity="0.35"
        />
      </g>
      <circle cx="12" cy="12" r="3.7" fill="#FFF" />
      <g transform="rotate(-32 12 12)">
        <path
          d="M2 12a10 3.5 0 0 0 20 0"
          fill="none"
          stroke="#FFF"
          strokeWidth="1.7"
          strokeLinecap="round"
        />
        <circle cx="20.6" cy="10.3" r="2" fill="#C4B5FD" />
        <circle cx="20.6" cy="10.3" r="0.95" fill="#FFF" />
      </g>
    </svg>
  );
}

export default SvgOrbit;
